import { registerQuery } from 'data-fetching-client';
import { fetchGenericChannelsWithCapabilities } from '../client/fetchGenericChannelsWithCapabilities';
export const FETCH_GENERIC_CHANNELS_WITH_CAPABILITIES_QUERY = registerQuery({
  fieldName: 'genericChannelsWithCapabilities',
  fetcher: fetchGenericChannelsWithCapabilities
});